
export default {
	name: "ScrollTriggeredModal",
	mounted() {
		// Add escape key listener
		document.addEventListener("keydown", this.handleEscapeKey);
	},
	beforeDestroy() {
		// Remove escape key listener
		document.removeEventListener("keydown", this.handleEscapeKey);
	},
	methods: {
		closeModal() {
			this.$emit("close");
		},
		handleEscapeKey(event) {
			if (event.key === "Escape") {
				this.closeModal();
			}
		},
	},
};
